<template>
  <div class="product-options block" v-if="categoriesHiddenWhenDisabled == 0 || groupedCategory.active === 1">
    <div class="product-options__icon" :class="`product-options__icon--${groupedCategory.id}`" v-bind:style="{ 'background-image': 'url('+ headerBackground + ')' }">
      <icon :iconID="groupedCategory.id" />
    </div>

    <div class="product-options__toggle" v-if="categoriesHiddenWhenDisabled == 0 && !groupedCategory.required  ">
      <toggle-button
        :color=switchColor
        :labels="{ checked: 'AAN', unchecked: 'UIT' }"
        :width="72"
        :height="32"
        :font-size="12"
        :value="groupedCategory.active === 1"
        @change="OnChangeOptionGroup"
      />
    </div>
    <div
      class="product-options__group"
      v-for="category in groupedCategory.children"
      :key="category.id"
      :class="{ 'product-options__group--disabled': groupedCategory.active !== 1 }"
    >
      <h3 class="product-options__title">{{ category.title }}</h3>
      <div class="product-options__description" v-html="category.description"></div>

      <div class="product-options__categories">
        <div class="option-category">
          <div
            class="option"
            v-for="(option, i) in category.products"
            :key="`option-${option.product_id}`"
            :class="{
              'product-options--disabled': checkDisabled(option),
              'hidden': isHidden(option),
            }"
          >
            <label>


              <div class="option__input">
<!--                <input-->
<!--                  type="radio"-->
<!--                  @click="trySelectOption($event, option, category.id, category)"-->
<!--                  :name="`option_${category.id}`"-->
<!--                  :disabled=false-->
<!--                  :value="1"-->
<!--                  v-model="option.active"-->
<!--                  v-if="category.selector === 'single'"-->
<!--                  :key="`radio-${option.product_id}`"-->
<!--                />-->
<!--                <input-->
<!--                  type="checkbox"-->
<!--                  @click="trySelectOption($event, option, category.id, category)"-->
<!--                  :name="`option_${category.id}`"-->
<!--                  :disabled="option.type === 'BASIS'"-->
<!--                  :checked="option.active"-->
<!--                  v-model="option.active"-->
<!--                  :key="`checkbox-${option.product_id}`"-->
<!--                  v-else-->
<!--                />-->
                <input
                    type="radio"
                    @change="trySelectOption($event, option, category.id, category)"
                    :name="`option_${category.id}`"
                    :disabled="checkDisabled(option)"
                    :value="1"
                    :checked="option.active === 1"
                    v-if="category.selector === 'single'"
                    :key="`radio-${option.product_id}`"
                />
                <input
                    type="checkbox"
                    @change="trySelectOption($event, option, category.id, category)"
                    :name="`option_${category.id}`"
                    :disabled="option.type === 'BASIS'"
                    :checked="option.active === 1"
                    :key="`checkbox-${option.product_id}`"
                    v-else
                />
                <span></span>
              </div>
              <div class="option__content">
                <h5 class="option__title">{{ option.product_name }}</h5>
                <div class="option__icon" v-if="option.product_description">
                  <icon :icon="`info-circle.svg`" />
                  <div class="block option__description">
                    <div class="option__header-container">
                      <icon class="description__icon" :icon="`info-circle.svg`" />
                      <h1 class="description__title">
                        {{ option.product_name }}
                      </h1>
                    </div>
                    <p class="description__body" v-html="option.product_description"></p>
                  </div>
                </div>
              </div>
            </label>
            <div class="option__input option__input--amount" v-if="option.product_type == 3">
              <div class="option__amount">
                <button
                    type="button"
                    class="option__amount-btn"
                    :disabled="(option.amount || 0) <= 0"
                    @click="changeAmount(option, category, -1)"
                >
                  −
                </button>

                <p class="option__amount-value">{{ option.amount || 0 }}</p>

                <button
                    type="button"
                    class="option__amount-btn"
                    :disabled="isMaxReached(option)"
                    @click="changeAmount(option, category, 1)"
                >
                  +
                </button>
              </div>
            </div>
            <div v-if="option.product_interval === 'EENMALIG'">
              <div class="option__price" v-if="option.product_price !== 0">
                {{ quantityAdjustedPrice(option, option.product_price) | toDisplayPrice }}
                <div class="option__price-interval">
                  {{ option.product_interval }}
                </div>
                <span v-if="option.product_type === 3 && option.amount > 1" class="option__price-qty">
                  ({{ option.amount }} × {{ option.product_price | toDisplayPriceDelta }})
                </span>
              </div>
              <div class="option__price" v-else-if="option.initialActive">INBEGREPEN</div>
              <div class="option__price" v-else>GRATIS</div>
            </div>
            <div v-else>
              <div class="option__price" v-if="option.product_price > 99998">
                op aanvraag
              </div>
              <div class="option__price" v-else-if="option.product_price !== 0 && category.selector !== 'multiple'">
                {{ quantityAdjustedPrice(option, option.product_price) | toDisplayPriceDelta }} / mnd
                <span v-if="option.product_type === 3 && option.amount > 1" class="option__price-qty">
                  ({{ option.amount }} × {{ option.product_price | toDisplayPriceDelta }})
                </span>
              </div>
              <div class="option__price" v-else-if="option.product_price !== 0">
                {{ quantityAdjustedPrice(option, option.product_price) | toDisplayPriceDelta }}
                / mnd
                <span v-if="option.product_type === 3 && option.amount > 1" class="option__price-qty">
                  ({{ option.amount }} × {{ option.product_price | toDisplayPriceDelta }})
                </span>
              </div>
              <div class="option__price" v-else-if="option.initialActive">INBEGREPEN</div>
              <div class="option__price" v-else>GRATIS</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleButton from '../../node_modules/vue-js-toggle-button/src/Button' // Import directly from node_modules because of css issues.
import swal from 'sweetalert'
import State from '../state'
import productHelpers from '../helpers/productHelpers'
import Icon from '../components/icon'
import priceFilters from '../filters/priceFilters'
import priceHelpers from '../helpers/priceHelpers'

export default {
  computed: {
    switchColor: function () {
      return getComputedStyle(document.documentElement).getPropertyValue('--switch-color')
    },
    assetPath () {
      let path
      /* eslint-disable no-undef */
      if (typeof PlinqApiUrlData !== 'undefined') {
        path = PlinqApiUrlData.VUE_APP_ASSETS_PATH
        /* eslint-enable no-undef */
      } else {
        path = process.env.VUE_APP_ASSETS_PATH
      }

      return path
    },
    headerBackground: function () {
      const background = process.env.VUE_APP_DETAILS_FORM_HEADER_IMAGE
      if (background === undefined || background === null) return null
      return "'" + this.assetPath + background + "'"
    },
    categoriesHiddenWhenDisabled: function () {
      return process.env.VUE_APP_PRESET_CATEGORIES_HIDDEN_WHEN_DISABLED
    }
  },
  components: {
    ToggleButton,
    Icon
  },
  props: {
    groupedCategory: Object
  },
  methods: {
    isMaxReached(option) {
      const max = option.max_amount ?? Infinity;
      return (option.amount || 0) >= max;
    },
    quantityAdjustedPrice (option, price) {
      if (option.product_type === 3 && (option.amount || 0) > 0) {
        return price * option.amount
      }
      return price
    },
    // changeAmount(option, category, delta) {
    //   console.log(option.max_amount);
    //   console.log(option.product_type);
    //   console.log(option.amount);
    //
    //   const max = option.max_amount ?? Infinity;
    //   const current = option.amount || 0;
    //   let next = current + delta;
    //
    //   // clamp
    //   next = Math.max(0, Math.min(next, max));
    //
    //
    //   if (next <= 0) {
    //     option.amount = 0;
    //   } else {
    //     option.amount = next;
    //   }
    //
    //   if(current === 0 || next === 0)
    //   this.trySelectOption(null, option, category.id, category);
    //
    //   console.log("amount after change",option.amount);
    //
    // },
    activateProduct (product) {
      console.log("activate", product);
      product.active = 1
      if (product.product_type === 3 && !(product.amount > 0)) {
        product.amount = 1
      }
      State.selection.categories = priceHelpers.addExtraPriceProperty(State.selection.categories)

    },

    deactivateProduct (product) {
      console.log("deactivate product", product);
      product.active = 0
      if (product.product_type === 3) {
        product.amount = 0
      }
      State.selection.categories = priceHelpers.addExtraPriceProperty(State.selection.categories)

    },
    changeAmount (option, category, delta) {
      const max = option.max_amount ?? Infinity
      const current = option.amount || 0
      const next = Math.max(0, Math.min(current + delta, max))

      option.amount = next

      if ( next === 0) {
        this.trySelectOption(null, option, category.id, category);
        option.active = 0;
        option.amount = 0;
      } else if (next === 1 && current === 0) {
        // amount changed but stayed non-zero (e.g. 2 -> 3) — no active toggle,
        // still need to persist the new amount and recompute pricing
        this.trySelectOption(null, option, category.id, category);
        option.active = 1
      }

    },
    checkDisabled (product) {
      return productHelpers.checkDisabled(product)
    },
    isHidden (product) {
      const shouldBeHidden = product.extra_price_base === null
      if (shouldBeHidden) {
        product.active = 0
      }
      return shouldBeHidden
    },
    // selectOption (productID, categoryID, amount, option) {
    //   State.selection.categories.map(category => {
    //     console.log("category.selector !== 'multiple'", category.selector !== 'multiple');
    //     if (category.id === categoryID && category.selector !== 'multiple') {
    //       category.products = category.products.map(product => {
    //         console.log('selectoption', product.name);
    //         if (
    //           product.product_id === productID &&
    //           !productHelpers.checkDisabled(product)
    //         ) {
    //           product.active = 1
    //
    //         } else {
    //           product.active = 0
    //
    //         }
    //         product.amount = amount;
    //         option.amount = amount;
    //         return product
    //       })
    //     }
    //
    //     return category
    //   })
    //
    //   State.selection.categories = priceHelpers.addExtraPriceProperty(
    //     State.selection.categories
    //   )
    // },
    // selectOption (productID, categoryID, amount, option) {
    //   console.log("selectOption", option.product_name );
    //   State.selection.categories.map(category => {
    //     console.log("single")
    //
    //     if (category.id !== categoryID) return category
    //
    //     if (category.selector !== 'multiple') {
    //       category.products.forEach(product => {
    //         if (product.product_id === productID && !productHelpers.checkDisabled(product)) {
    //           // product.active = 1
    //           // product.amount = amount
    //           option.active = 1;
    //           this.activateProduct(product);
    //         } else {
    //           option.active = 0;
    //           this.deactivateProduct(product);
    //           // product.active = 0
    //           // don't touch amount on unrelated products
    //         }
    //       })
    //     } else {
    //       console.log("multiple")
    //
    //       const product = category.products.find(p => p.product_id === productID)
    //       // if (product && !productHelpers.checkDisabled(product)) {
    //       //   product.active = amount > 0 ? 1 : (product.active === 1 ? 0 : 1)
    //       //   product.amount = amount
    //       // }
    //       if (product && !productHelpers.checkDisabled(product)) {
    //         option.active = 1;
    //         this.activateProduct(product);
    //       } else {
    //         option.active = 0;
    //         this.deactivateProduct(product);
    //       }
    //     }
    //     return category
    //   })
    //
    // },
    selectOption (productID, categoryID, amount, option) {
      console.log("selectOption", option.product_name)
      State.selection.categories.map(category => {
        if (category.id !== categoryID) return category

        if (category.selector !== 'multiple') {
          // single-select: activate the chosen one, deactivate all siblings
          category.products.forEach(product => {
            if (product.product_id === productID && !productHelpers.checkDisabled(product)) {
              this.activateProduct(product)
            } else {
              this.deactivateProduct(product)
            }
          })
        } else {
          // multiple-select: toggle just this product based on its current state
          const product = category.products.find(p => p.product_id === productID)
          if (!product) return category

          if (product.active === 1) {
            this.deactivateProduct(product)
          } else if (!productHelpers.checkDisabled(product)) {
            this.activateProduct(product)
          }
        }
        return category
      })
    },
    OnChangeOptionGroup () {
      this.groupedCategory.children.forEach(category => {
        category.active = category.active === 0 ? 1 : 0
        category.products.forEach(p => {
          if (category.active === 0) {
            p.active = 0
          } else {
            if (p.type === 'BASIS') {
              p.active = 1
            }
          }
        })
      })
    },
    checkNotNeeded (product, category) {
      return productHelpers.checkNotNeeded(product, category)
    },
    checkDependantsEnabled (option) {
      return productHelpers.checkDependantsEnabled(option)
    },
    checkNotCombinedWithBasis (option) {
      return productHelpers.checkNotCombinedWithBasis(option)
    },
    trySelectOption (event, option, categoryID, category) {
      console.log('trySelectOption')
      console.log(option.active);
      if (!this.checkDisabled(option) && !this.checkNotNeeded(option, category) && !this.checkDependantsEnabled(option) && !this.checkNotCombinedWithBasis(option)) {
        console.log('just change')
        this.selectOption(option.product_id, categoryID, option.amount, option)
      } else {
        console.log('check before change')
        const requirements = productHelpers.findRequired(option)
        const notCombinedWith = productHelpers.findNotCombinedWith(option)
        const notCombinedWithBASIS = productHelpers.findNotCombinedWithBASIS(option)
        const notNeeded = productHelpers.findAllWithSameRequirementsDeactivated(option, category)
        const enabledDependants = productHelpers.findAllEnabledDependants(option)

        console.log(notCombinedWithBASIS)

        if (requirements.length > 0) {
          const productNames = requirements.map(p => p.product_name).join(' en ')
          var text = `De volgende opties zijn hiervoor verplicht: ${productNames}. En zijn ook geactiveerd.`
          if(requirements.length === 1) {
            text = `De volgende optie is hiervoor verplicht: ${productNames}. En is ook geactiveerd.`
          }


          swal({
            title: 'Let op',
            // text: `Om deze optie te activeren moet ${productNames} ook geactiveerd zijn.\n\nWil je dit doen?`,
            text: text ,
            icon: 'warning',
            buttons: {
              yes: {
                text: 'Oké',
                value: true
              }
            }
          }).then((activate) => {
           // if (activate) {
            requirements.forEach(r => this.activateProduct(r))
            this.activateProduct(option)
           // }
          })
        } else if (notCombinedWith.length > 0) {
          const productNames = notCombinedWith.map(p => p.product_name).join(' en ')
          this.selectOption(option.product_id, categoryID, option.amount, option)
          swal({
            title: 'Let op',
            text: `Deze optie kan niet samen met ${productNames}.\nEn is gedeactiveerd.`,
            icon: 'warning',
            buttons: {
              yes: {
                text: 'Oke',
                value: true
              }
            }
          }).then((deactivate) => {
            if (deactivate) {
              notCombinedWith.forEach(r => this.deactivateProduct(r))
              this.activateProduct(option)
            }
          })
        } else if (notCombinedWithBASIS.length > 0) {
          const productNames = notCombinedWithBASIS.map(p => p.product_name).join(' en ')
          var currentSelectedSingle = null
          State.selection.categories.map(category => {
            if (category.id === categoryID && category.selector !== 'multiple') {
              category.products.map(product => {
                if (
                  product.product_id !== option.product_id &&
                  product.active === 1
                ) {
                  currentSelectedSingle = product
                }
              })
            }
          })
          currentSelectedSingle.active = 0
          swal({
            title: 'Let op',
            text: `Deze optie kan niet samen met ${productNames}.\nEn is gedeactiveerd.`,
            icon: 'warning',
            buttons: {
              yes: {
                text: 'Oke',
                value: true
              }
            }
          })

          //     .then((activate) => {
          //   if (activate) {
          //     this.selectOption(option.product_id, categoryID)
          //     // deactivate notcombined with product
          //
          //
          //     for(var productToDeactivate in notCombinedWithBASIS) {
          //       for (let i = 0; i < State.selection.categories.length; i++) {
          //         for (let j = 0; j < State.selection.categories[i].products.length; j++) {
          //           var productID = State.selection.categories[i].products[j].product_id
          //           if (productID === notCombinedWithBASIS.product_id) {
          //             State.selection.categories[i].products[j].active = 0
          //           }
          //         }
          //       }
          //     }
          //       // for(let category in State.selection.categories){
          //       //   console.log(category.id)
          //       //   for(let product in category.products){
          //       //     console.log(product.product_id)
          //       //     if(product.product_id === notCombinedWithBASIS.product_id){
          //       //       product.active = 0
          //       //       console.log('product to deactivate in state')
          //       //       console.log(product)
          //       //     }
          //       //   }
          //       // }
          //
          //
          //   } else {
          //     this.selectOption(currentSelectedSingle.product_id, categoryID)
          //     currentSelectedSingle.active = 1
          //   }
          // })
              .then((deactivate) => {
                if (deactivate) {
                  notCombinedWithBASIS.forEach(r => this.deactivateProduct(r))
                  this.activateProduct(option)
                }
              })
              .finally(() => { this.$forceUpdate() })
        } else if (notNeeded.length > 0) {
          const productNames = notNeeded.map(p => p.product_name).join(' en ')
          swal({
            title: 'Let op',
            text: `Als u deze optie deactiveert is ${productNames} niet meer nodig.\n\nWil je die ook deactiveren?`,
            icon: 'warning',
            buttons: {
              cancel: 'Nee',
              yes: {
                text: 'Ja',
                value: true
              }
            }
          }).then((deactivate) => {
            if (deactivate) {
              notNeeded.forEach(r => this.deactivateProduct(r))
              this.deactivateProduct(option)   // was: option.active = 0
            }
          })
          this.deactivateProduct(option)
        } else if (enabledDependants.length > 0) {
          const productNames = enabledDependants.map(p => p.product_name).join(' en ')
          swal({
            title: 'Let op',
            text: `Als u deze optie deactiveert is ${productNames} niet meer mogelijk.\n\nWil je die ook deactiveren?`,
            icon: 'warning',
            buttons: {
              cancel: 'Annuleren',
              yes: {
                text: 'Beide deactiveren',
                value: true
              }
            }
          }).then((deactivate) => {
            if (deactivate) {
              enabledDependants.forEach(r => this.deactivateProduct(r))
              this.deactivateProduct(option)   // was: option.active = 0
            } else {
              this.activateProduct(option)     // was: option.active = 1
            }
          })
        }

      }
      const activeWhen = productHelpers.findAllActiveWhen(option)

      if (activeWhen.length > 0) {
        activeWhen.forEach(r => {
          if (!option.active) {
            this.activateProduct(r)
          } else {
            this.deactivateProduct(r)
          }
        })
      }
    }
  },
  filters: {
    toDisplayPrice: priceFilters.toDisplayPrice,
    toDisplayPriceDelta: priceFilters.toDisplayPriceDelta
  }
}
</script>

<!-- seperate style for css variable as this cannot be expoed to button-switch in scoped style -->
<style lang="scss">
:root {
  --switch-color: #{color(2)};
}

</style>

<style scoped lang="scss">

.hidden {
  display: none !important;
}

div.product-options {
  position: relative;
  margin-bottom: 50px;
  padding: 30px;
}

.product-options__group--disabled {
  opacity: 0.2;
  pointer-events: none;
}

// .product-options--disabled {
//   opacity: 0.2;
// }

.product-options__group:not(:last-child) {
  margin-bottom: 50px;
}

.product-options__icon {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 100%;
}

.product-options__icon--100 {
  background-color: color('internet');
}

.product-options__icon--200 {
  background-color: color('telefonie');
}

.product-options__icon--300 {
  background-color: color('televisie');
}

.product-options__icon--400 {
  background-color: color('apparatuur');
}

.product-options__icon--500 {
  background-color: color('intallatie');
}

.product-options__icon--600 {
  background-color: color('extra');
}

.product-options__icon--700 {
  background-color: color('extra');
}

.product-options__icon--900 {
  background-color: color('extra');
}

.product-options__toggle {
  position: absolute;
  top: 15px;
  right: 15px;
}

.product-options__title {
  font-size: 25px;
  font-weight: 700;
  margin: 0;
  margin-bottom: 10px;
}

.product-options__description {
  font-weight: 300;
  line-height: 25px;
  padding-bottom: 10px;

  border-bottom: solid 1px $color-border;
}

.option-category__title {
  font-size: 20px;

  &::after {
    content: "";
    display: block;
    width: 250px;
    height: 1px;
    background-color: $color-border;
    margin: 15px 0;
  }
}

.option {
  display: grid;
  grid-template-columns: 1fr 90px auto; // label | amount | price
  align-items: center;
  column-gap: 15px;
  margin: 20px auto;

  label {
    grid-column: 1;
    display: flex;
    align-items: center;
  }
}

.option__input--amount {
  grid-column: 2;
  justify-self: start;
}

// price wrapper is always the last direct child of .option,
// regardless of whether the amount column exists on that row
.option > div:last-child {
  grid-column: 3;
  justify-self: end;
  text-align: right;
  min-width: 150px;
}

.option__input {
  position: relative;
  width: 35px;
  height: 100%;
  cursor: pointer;

  input {
    cursor: inherit;
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }

  input:checked ~ span {
    border-color: color('check');

    &::after {
      content: "";
      position: absolute;
      top: 2px;
      left: 2px;
      right: 2px;
      bottom: 2px;
      background-color: color('check');
      border-radius: 100%;
    }
  }

  span {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    height: 15px;
    width: 15px;
    background-color: #fff;
    border: 2px solid #4d4d4d;
    border-radius: 100%;

    cursor: inherit;
  }
}
.option__input--amount {
  width: auto;
  min-width: 90px; // enough for − / number / + without crowding
  display: flex;
  align-items: center;
  cursor: default; // the container itself isn't clickable, only the buttons are
}
.option__amount {
  display: flex;
  align-items: center;
  gap: 8px;
}

.option__amount-value {
  margin: 0;
  min-width: 20px;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
}

.option__amount-btn {
  all: unset; // strip inherited/global button styles causing the black box
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 100%;
  border: 2px solid #4d4d4d;
  color: #4d4d4d;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  box-sizing: border-box;

  &:hover:not(:disabled) {
    border-color: color('check');
    color: color('check');
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.option__price-qty {
  display: block;
  font-weight: 400;
  font-size: 0.75em;
  opacity: 0.7;
  white-space: nowrap;
}

.option__content {
  cursor: pointer;
}

.option__title {
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  display: inline-block;

  cursor: inherit;
}

.option__icon {
  display: inline-block;

  height: 2.5em;
  width: 2.5em;

  &:hover .option__description {
    display: block;
    position: absolute;
    background-color: color(2);
    z-index: 99;
    color: color(6);
    width: 100%;
    left: -10%;
    padding: 20px 50px;
  }
}

.description__icon {
  display: inline-block;
  height: auto;
  width: 2em;
  color: $text-color;
  opacity: 0.5;
}

.description__title {
  display: inline-block;
  margin: 0 10px !important;
  font-weight: bold;
  font-size: 25px;
}

.description__body {
  line-height: 1.5em;
}

.option__header-container {
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
}

.option__description {
  display: none;
}

.option__price {
  font-weight: 700;
}

.option__price-interval {
  font-size: 0.8em;
  display: inline;
}
</style>
